<template>
  <!-- 对话框 -->
  <div>
    <el-dialog :title="config.title" :visible.sync="visible" :width="config.width ? config.width : ''">
      <el-form :ref="thisRef" :model="formData" :rules="rules" :label-width="config.labelWidth ? config.labelWidth + 'px' : '80px'" status-icon>
        <template v-for="(item, index) in config.formItems">
          <el-form-item :label="item.label" :prop="item.prop" :key="index" v-if="item.type == 'input'">
            <el-input v-model="formData[item.prop]" :placeholder="item.placeholder"></el-input>
          </el-form-item>
          <el-form-item :label="item.label" :prop="item.prop" :key="index" v-if="item.type == 'text'">
            <span>{{ formData[item.prop] }}</span>
          </el-form-item>
          <el-form-item :label="item.label" :prop="item.prop" :key="index" v-if="item.type == 'select'">
            <el-select v-model="formData[item.prop]" :placeholder="item.placeholder" class="dialog-select" @change="selectChangeDo(item.linkageApi, $event)">
              <template v-for="(selectItem, selectIndex) in item.items">
                <el-option :label="selectItem.name" :value="selectItem.value" :key="selectIndex"></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item :label="item.label" :prop="item.prop" :key="index" v-if="item.type == 'checkbox'">
            <el-checkbox-group v-model="formData[item.prop]">
              <el-checkbox v-for="(checkItem, checkIndex) in item.items" :label="checkItem.value" :key="checkIndex">{{ checkItem.name }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item :label="item.label" :prop="item.prop" :key="index" v-if="item.type == 'timepicker'">
            <el-time-picker value-format="HH:mm:ss" v-model="formData[item.prop]" :placeholder="item.placeholder ? item.placeholder : '请选择时间'"></el-time-picker>
          </el-form-item>
        </template>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom-cancel-button" @click="handle(1)" :disabled="disabled" v-if="btns.closeBtn">{{ btns.closeTitle ? btns.closeTitle : '取消' }}</el-button>
        <el-button class="bottom-sure-button" type="primary" @click="handle(2)" :disabled="disabled" v-if="btns.submitBtn">{{ btns.submitTitle ? btns.submitTitle : '确定' }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      thisRef: this._uid + 'dialog',
      formData: {},
      rules: {},
      disabled: false,
      visible: false,
      btns: { closeBtn: true, submitBtn: true, closeTitle: '取消', submitTitle: '确定' },
    }
  },
  props: ['config', 'dialogSubmit', 'dialogClose', 'selectChange', 'singleFields'],
  created() {},
  watch: {
    visible: function (val) {
      let that = this
      if (!val) {
        // console.log('++++++++++++++++++++++',that.$refs[that.config.ref]);
        that.$refs[that.thisRef].resetFields()
        that.disabled = false
      } else {
        that.initData()
        // that.$refs[that.thisRef].clearValidate()
      }
    },
    config: function () {
      this.initData()
    },
  },
  methods: {
    init() {
      if (this.config.btns) {
        if (this.config.btns.closeBtn != undefined) {
          this.btns.closeBtn = this.config.btns.closeBtn
        }
        if (this.config.btns.submitBtn != undefined) {
          this.btns.submitBtn = this.config.btns.submitBtn
        }
        if (this.config.btns.closeTitle != undefined) {
          this.btns.closeTitle = this.config.btns.closeTitle
        }
        if (this.config.btns.submitTitle != undefined) {
          this.btns.submitTitle = this.config.btns.submitTitle
        }
      }
      // if(this.config.btns.closeBtn==undefined||this.config.btns.closeBtn==''){
      // 	this.config.btns.closeBtn = true
      // }
      // if(this.config.btns.submitBtn==undefined||this.config.btns.submitBtn==''){
      // 	this.config.btns.submitBtn = true
      // }
    },
    handle(type) {
      if (type == 1) {
        this.visible = false
      } else if (type == 2) {
        let that = this
        this.disabled = true
        this.$refs[this.thisRef].validate((valid) => {
          if (valid) {
            let adata = JSON.parse(JSON.stringify(that.formData))
            if (that.config.api) {
              that.submit(adata)
            } else {
              that.dialogSubmit(adata)
            }
          } else {
            this.disabled = false
            return
          }
        })
      } else {
      }
    },

    createRules() {
      let items = this.config.formItems
      let rs = this.config.rules
      let reg = /^[a-zA-z]+-[0-9]+$/
      for (let i = 0; i < items.length; i++) {
        let r = rs[items[i].prop]
        this.rules[items[i].prop] = []
        if (r == undefined) {
          break
        }
        for (let ii = 0; ii < r.length; ii++) {
          if (r[ii] == 'required') {
            this.rules[items[i].prop].push({
              required: true,
              message: items[i].type == 'input' ? '请填写' : '请选择' + items[i].label,
              trigger: 'change',
            })
          }
          if (r[ii] == 'number') {
            this.rules[items[i].prop].push({
              pattern: /^[0-9]+$/,
              message: '请填写数字值',
              trigger: 'change',
            })
          }
          if (r[ii] == 'phone') {
            this.rules[items[i].prop].push({
              pattern: /^1[3456789]\d{9}$ /,
              message: '请填写正确手机号码',
              trigger: 'change',
            })
          }
          if (r[ii] == 'arrayRequired') {
            this.rules[items[i].prop].push({
              type: 'array',
              required: true,
              message: '请选择' + items[i].label,
              trigger: 'change',
            })
          }
          if (reg.test(r[ii])) {
            let arr = r[ii].split('-')
            if (arr[0] == 'max') {
              this.rules[items[i].prop].push({
                max: parseInt(arr[1]),
                message: '最大长度' + arr[1] + '个字符',
                trigger: 'change',
              })
            } else if (arr[0] == 'min') {
              this.rules[items[i].prop].push({
                min: parseInt(arr[1]),
                message: '最小长度' + arr[1] + '个字符',
                trigger: 'change',
              })
            }
          }
        }
      }
    },
    initData() {
      if (this.config.formData != undefined) {
        this.formData = JSON.parse(JSON.stringify(this.config.formData))
      }
    },
    dialogShow() {
      this.visible = true
    },
    dialogHide() {
      this.visible = false
    },
    selectChangeDo(api, val) {
      if (api) {
        this.selectChange(api, val)
      }
    },
    submit(data) {
      let that = this
      this.$API[this.config.api](data).then((res) => {
        this.$emit('succHandler')
        that.dialogHide()
      })
    },
  },
  mounted() {
    this.init()
    this.createRules()
    this.initData()
  },
}
</script>

<style scoped="">
.del-dialog-cnt {
  font-size: 16px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/hbDialog.vue